import { render } from "./NovaMensagemDialogComponent.vue?vue&type=template&id=5b0f4ee6&scoped=true&ts=true"
import script from "./NovaMensagemDialogComponent.vue?vue&type=script&lang=ts"
export * from "./NovaMensagemDialogComponent.vue?vue&type=script&lang=ts"

import "./NovaMensagemDialogComponent.vue?vue&type=style&index=0&id=5b0f4ee6&lang=scss&scoped=true"
import "./NovaMensagemDialogComponent.vue?vue&type=style&index=1&id=5b0f4ee6&lang=css"
import "./NovaMensagemDialogComponent.vue?vue&type=style&index=2&id=5b0f4ee6&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5b0f4ee6"]])

export default __exports__